import { Controller } from "@hotwired/stimulus"

// Expands a grouped report row to reveal its time entries. The detail row holds
// a lazy Turbo Frame, so the entries are fetched the first time it is shown.
export default class extends Controller {
  static targets = ["detail", "icon"]

  toggle() {
    const expanded = this.detailTarget.classList.toggle("hidden")
    this.iconTarget?.classList.toggle("rotate-90", !expanded)
  }
}
